<template>
    <div class="indexpage-mobile-numbers">
        <ui-link v-bind:to="{ name: 'stats' }" class="router-link__no-style indexpage-mobile-numbers__price">
            <template v-if="price">
                <IconGram class="indexpage-mobile-numbers__ton-logo" />${{ price.toFixed(2) }}
            </template>
            <span v-else class="skeleton" style="width: 60px;">test</span>
        </ui-link>
        <news-line />
    </div>
</template>

<script>
import { getExchangeRateAndTrend } from '~/api/coingecko.js';
import IconGram from '@img/icons/tonscan/gram-icon.svg?vue';
import NewsLine from './NewsLine.vue';

export default {
    data() {
        return {
            price: null,
        };
    },

    mounted() {
        this.getMarketPrice();
    },

    methods: {
        async getMarketPrice() {
            try {
                const [price] = await getExchangeRateAndTrend('USD');
                this.price = price;
            } catch (error) {
                console.error(error);
            }
        },
    },

    components: { IconGram, NewsLine },
};
</script>

<style lang="scss">
.indexpage-mobile-numbers {
    width: 100%;
    height: auto;
    display: flex;
    box-sizing: border-box;
    padding: 0 16px;

    &__ton-logo {
        width: 18px;
        height: 18px;
        margin-right: 5px;
    }

    &__price {
        font-weight: 500;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-right: 75px;
    }
}
</style>
